const DROPSHIP_SHIPPED_BY = 'dropship_shipped_by_text';
const DROPSHIP_SHIPPED_FREE_BY = 'dropship_shipped_free_by_text';
const DROPSHIP_EXCLUDED_FROM_PROMOTIONS = 'dropship_excluded_from_promotions_text';

export {
  DROPSHIP_SHIPPED_BY,
  DROPSHIP_SHIPPED_FREE_BY,
  DROPSHIP_EXCLUDED_FROM_PROMOTIONS
};
